
import { useAuth } from '../../Context/authContext'
import { signInWithEmailAndPassword } from "firebase/auth";
import React from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../../Firebase";
import "./SignIn.css";
import { useEffect } from 'react';




const SignIn = () => {
  const [open,setOpen] = useState(false);
  const { userid, setUserid, currentUser, setCurrentUser} = useAuth();
  const [message, setMessage] = useState("");
  const [signForm, setSignForm] = useState({});
  const navigate = useNavigate();


  
  
  const handleChange = (e) => {
    setSignForm({
      ...signForm,
      [e.target.name]: e.target.value,
    });
   
  };
  useEffect(()=>{
    if(open){
    setTimeout(() => {
      setOpen(false);
    }, 5000);
  }
  },[open])


  const handleSubmit = async (e) => {
    e.preventDefault();
    let mail = signForm.email
    await setUserid(mail)
    await signInWithEmailAndPassword(auth, signForm.email, signForm.password)
    .then(async() => {
      navigate(-1)
    
      setSignForm({})
      await setCurrentUser(true)
    })
    .catch(() => {
      
      setMessage("Incorrect Email/Password. Please try again.")
      setOpen(true)
    })
    // setMessage("");
  };
  
  return (
    <div className="sign-overlay">
      <div className="sign-container">
        <form action="" className="sign-form">
          <h1 className=" heading">
            SIGN IN<div className="bottom_line"></div>
          </h1>
          
          <div className="input-container">
        
            <input
              name="email"
              type="email"
              placeholder="Email"
              required
              className="input-field"
              onChange={(e) => handleChange(e)}
            />
            <input
              name="password"
              type="password"
              placeholder="Password"
              required
              className="input-field"
              onChange={(e) => handleChange(e)}
            />
          </div>
          {open && <div className='note' style={{paddingTop:"1rem",display:"flex",justifyContent:"center",alignItems:"center",width:"100%"}}>
            <span style={{textAlign:"center"}}>{message}</span>
            </div>}
          <Link to="/signup">Do not have an account? Sign up!</Link>
          <div className="input-bot">
            <p>
              <Link to="/forgotpw">Forgot Password?</Link>
            </p>
            <button type="submit" className="button-62" onClick={(e) => handleSubmit(e)}>
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignIn;
